import { useContext } from "react";
import { FacebookPixelContext } from "../contexts/FacebookPixelContext";

export const useFaceBookPixel = () => {
  const context = useContext(FacebookPixelContext);
  if (!context) throw new Error("useFaceBookPixel must be used within FacebookPixelProvider");
  return context;
};